import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './layouts/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceArea from './pages/ServiceArea';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import SummerACTuneUp from './pages/SummerACTuneUp';
import FurnaceInspection from './pages/FurnaceInspection';
import Accessibility from './pages/Accessibility';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="service-area" element={<ServiceArea />} />
          <Route path="contact" element={<Contact />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogPost />} />
          <Route path="summer-ac-tune-up" element={<SummerACTuneUp />} />
          <Route path="furnace-inspection" element={<FurnaceInspection />} />
          <Route path="accessibility" element={<Accessibility />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;